// extracted by mini-css-extract-plugin
module.exports = {"footerGame":"style_footerGame__1ZPOx","footerGameSweepstakes":"style_footerGameSweepstakes__3IE5n","footerGameBuyTimeButton":"style_footerGameBuyTimeButton__2XYAj"};